import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Hidden,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
  useTheme,
} from '@quillbot/design-system';
import createStyles from '@mui/styles/createStyles';
import { makeStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import React from 'react';
import 'lazysizes';
import Link from 'next/link';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import supportTrack from 'src/support/handlers/track';

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      [theme.breakpoints.down(1050)]: {
        padding: '0px 20px',
      },

      '& h1': {
        [theme.breakpoints.down(767)]: {
          fontSize: '23px',
        },
      },

      '& h2': {
        [theme.breakpoints.down(767)]: {
          fontSize: '23px',
          lineHeight: 'normal',
        },
      },

      '& h3': {
        fontSize: '24px',
        fontWeight: 'normal',
        paddingTop: '20px',
        marginBottom: '-5px',
        [theme.breakpoints.down(767)]: {
          fontSize: '20px',
        },
      },
      '& img': {
        margin: 'auto',
        [theme.breakpoints.down(1300)]: {
          maxWidth: '100%',
        },
      },
      '& h4': {
        fontSize: '20px',
        fontWeight: 'normal',
        textAlign: 'center',
      },
    },
    textRight: {
      textAlign: 'right',
      justifyContent: 'end',
      alignItems: 'center',
      [theme.breakpoints.down(767)]: {
        justifyContent: 'center',
        display: 'flex',
      },
    },
    textLeft: {
      textAlign: 'left',
      justifyContent: 'start',
      alignItems: 'center',
      [theme.breakpoints.down(767)]: {
        justifyContent: 'center',
        display: 'flex',
      },
    },
    topSection: {
      maxWidth: '885px',
      margin: '20px auto',
      textAlign: 'center',
      paddingTop: '22px',
      paddingBottom: '26px',
      '& h1': {
        marginBottom: '50px',
        [theme.breakpoints.down(767)]: {
          marginBottom: '20px',
        },
      },
      '& p': {
        lineHeight: '22px',
      },
      [theme.breakpoints.down(767)]: {
        paddingBottom: '0px',
      },
    },
    featureDescription: {
      maxWidth: '1012px',
      margin: '20px auto',
      paddingTop: '30px',
      // textAlign: 'center',
      [theme.breakpoints.down(767)]: {
        paddingTop: '0px',
        marginTop: '0px',
      },
    },
    yellowBoxWave: {
      backgroundImage: `url(./images/theme/${theme.palette.mode}/grammarChecker/yellowWave.png)`,
      minHeight: '100px',
      backgroundRepeat: 'no-repeat',
      width: '100%',
      backgroundPosition: 'center bottom',
      backgroundSize: '100%',
      marginBottom: '-5px',
    },

    yellowBoxHolder: {
      backgroundColor: theme.palette.grey[300],
      textAlign: 'center',
      paddingTop: '15px',
      paddingBottom: '65px',
      marginBottom: '43px',
      [theme.breakpoints.down(767)]: {
        paddingTop: ' 0px',
        paddingBottom: '20px',
      },

      '& h3': {
        [theme.breakpoints.down(767)]: {
          fontSize: '20px',
          paddingTop: ' 0px',
          marginTop: '0px',
        },
      },
    },

    yellowBoxInner: {
      maxWidth: '900px',
    },

    expPanel: {
      border: '1px solid',
      borderWidth: '1px 0px',
      borderColor: theme.palette.divider,
      backgroundColor: theme.palette.grey[800],
      boxShadow: 'none',
      marginBottom: '0px !important',
      // paddingBottom: '16px',
      '&:not(:last-child)': {
        borderBottom: 0,
      },
      '&:before': {
        display: 'none',
      },
      '&$expanded': {
        margin: 0,
      },
    },
    expDetail: {
      paddingLeft: '8px',
      paddingBottom: '32px',
      fontSize: '16px',
    },
    root: {
      // width: "100%",
      fontWeight: 600,
      minHeight: '70px',
      // color: '#4F4F4F',
      padding: '8px',
      color: '#484B4E',
      '&:hover': {
        color: theme.palette.primary.dark,
        backgroundColor: theme.palette.grey[50],
      },

      [theme.breakpoints.down(767)]: {
        fontSize: '15px',
      },
    },
    expanded: {
      color: theme.palette.primary.main,
      // backgroundColor: '#ffffff',
    },
    heading: {
      fontWeight: 600,
    },

    tableMobileHolder: {
      boxShadow: 'none',
      marginBottom: '10px',
      overflow: 'hidden',
      borderRadius: '0px',
    },

    tableMobile: {
      width: '100%',
      border: `1px ${theme.palette.divider} solid`,

      '& img': {
        margin: 'inherit',
        marginRight: '10px',
        [theme.breakpoints.down('md')]: {
          maxWidth: '40px',
        },
      },
    },
    rowReverse: {
      [theme.breakpoints.down(600)]: {
        // flexDirection: 'column-reverse',
        flexWrap: 'wrap-reverse',
      },
    },

    grammarRuleBox: {
      marginTop: '23px',
      paddingTop: '20px',
      marginBottom: '45px',
      '& img': {
        margin: '0px',
      },

      [theme.breakpoints.down(767)]: {
        marginBottom: '10px',
        marginTop: '0px',
      },
    },

    grammarRuleBoxContentLeft: {
      paddingLeft: '50px',
      paddingRight: '30px',
    },
    grammarRuleBoxContentRight: {
      paddingRight: '50px',
      paddingLeft: '30px',
    },

    grammarRuleBoxContent: {
      // paddingTop: '35px',

      '& h3': {
        [theme.breakpoints.down(767)]: {
          paddingTop: '0px',
          marginTop: '10px',
        },
      },

      [theme.breakpoints.down(1100)]: {
        paddingRight: '0px',
        paddingLeft: '0px',
      },
    },

    grammarRuleBoxContentLast: {
      paddingLeft: '0px',
    },

    tableHolder: {
      padding: '60px 0px',
    },
    tableTitle: {
      maxWidth: '800px',
      margin: 'auto',
      '& h4': {
        [theme.breakpoints.down(767)]: {
          fontSize: '16px',
        },
      },
    },

    tablemobilePaddingContainer: {
      [theme.breakpoints.down(767)]: {
        paddingBottom: '30px',
      },
    },

    tableHolderContent: {
      border: '1px solid',
      borderColor: theme.palette.divider,
      borderRadius: '10px',
      overflow: 'hidden',
      maxWidth: '1100px',
      margin: '40px auto 100px',
      [theme.breakpoints.down(1080)]: {
        maxWidth: '1012px',
      },
    },

    tableContent: {
      '& tr': {
        '&:nth-child(3)': {
          '& td': {
            borderBottom: '1px solid',
            borderBottomColor: theme.palette.divider,
            '&:nth-child(1)': {
              borderBottom: '0px',
            },
          },
        },

        '& th': {
          borderRight: '1px solid',
          borderRightColor: theme.palette.divider,
          Height: '58px',
          fontSize: '20px',
          fontWeight: 'normal',
          textAlign: 'center',
          padding: '8px 20px',
          minWidth: '350px',
          '&:last-child': {
            borderRight: '0px',
          },
          [theme.breakpoints.down(1250)]: {
            minWidth: '227px',
          },
          [theme.breakpoints.down(767)]: {
            minWidth: '100%',
          },
        },
        '& td': {
          borderRight: '1px solid',
          borderRightColor: theme.palette.divider,
          height: '58px',
          // color: '#484B4E',
          fontSize: '16px',
          padding: '8px 20px',
          minWidth: '350px',
          [theme.breakpoints.down(1250)]: {
            minWidth: '227px',
          },
          [theme.breakpoints.down(767)]: {
            minWidth: '100%',
          },

          '&:last-child': {
            borderRight: '0px',
          },
          '& strong': {
            fontWeight: 600,
          },
        },
      },
    },

    mobileTableBox: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },

    evenCell: {
      backgroundColor: theme.palette.background.default,
    },

    tableBox: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& img': {
        marginRight: '15px',
        marginLeft: '0px',
        maxWidth: '42px',
      },
    },

    tableTopicTh: {
      backgroundColor: theme.specialColors.GRAMMAR_CHECKER_TABLE_TOPIC,
      color: theme.specialColors.GRAMMAR_CHECKER_FONT_BLUE,
    },
    tableWrongTh: {
      backgroundColor: theme.palette.error.dark,
      color: theme.palette.error.main,
    },
    tableRightTh: {
      backgroundColor: theme.specialColors.GRAMMAR_CHECKER_TABLE_RIGHT,
      color: theme.specialColors.GRAMMAR_CHECKER_FONT_GREEN,
    },

    faqContainer: {
      backgroundColor: theme.palette.grey[800],
      padding: '30px 0px 140px',
      '& p': {
        [theme.breakpoints.down(767)]: {
          fontSize: '14px',
        },
      },
    },

    faqholder: {
      paddingTop: '20px',
    },

    ruleBoxBg: {
      backgroundImage: `url(./images/theme/${theme.palette.mode}/grammarChecker/ruleBoxBg.png)`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 96%',
      backgroundPosition: 'center 50px',

      [theme.breakpoints.down(767)]: {
        backgroundImage: `url(./images/theme/${theme.palette.mode}/grammarChecker/ruleBoxBgMobile.png)`,
        backgroundPosition: 'center 630px',
      },
    },

    faqInner: {
      maxWidth: '1012px',
      margin: 'auto',
    },

    tablemobileBgContainer: {
      backgroundImage: `url(./images/theme/${theme.palette.mode}/grammarChecker/tableBgDesktop.svg)`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundPosition: 'center 0px',
      [theme.breakpoints.down(900)]: {
        backgroundImage: 'none',
      },
    },
  })
);

const StyledTableCell = withStyles(() =>
  createStyles({
    head: {
      fontSize: 20,
      textAlign: 'center',
      border: '0px',
    },
    body: {
      fontSize: 14,
      border: '0px',
    },
  })
)(TableCell);

const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.background.default,
      },
    },
  })
)(TableRow);
function createData(topicColumn: any, wrongColumn: any, rightColumn: any) {
  return { topicColumn, wrongColumn, rightColumn };
}

const rows = [
  createData(
    'Subject-Verb Agreement',
    <span>
      My mom <span style={{ color: '#E86060', fontWeight: 'bold' }}>like</span> pizza and tacos.
    </span>,
    <span>
      My mom <span style={{ color: '#4C9459', fontWeight: 'bold' }}>likes</span> pizza and tacos.
    </span>
  ),
  createData(
    'Word Misuse',
    <span>
      The <span style={{ color: '#E86060', fontWeight: 'bold' }}>affect</span> of this change is
      unclear.
    </span>,
    <span>
      The <span style={{ color: '#4C9459', fontWeight: 'bold' }}>effect</span> of this change is
      unclear.
    </span>
  ),
  createData(
    'Comma Splices',
    <span>
      First I went to the grocery store,
      <span style={{ color: '#E86060', fontWeight: 'bold', position: 'relative', top: '10px' }}>
        ^
      </span>
      I went to the library afterwards.
    </span>,
    <span>
      First I went to the grocery store,
      <span style={{ color: '#4C9459', fontWeight: 'bold' }}> and then</span> I went to the library
      afterwards.
    </span>
  ),
  createData(
    'Singular vs. Plural Nouns',
    <span>
      Four pets found new <span style={{ color: '#E86060', fontWeight: 'bold' }}>home</span> today.
    </span>,
    <span>
      Four pets found new <span style={{ color: '#4C9459', fontWeight: 'bold' }}>homes</span> today.
    </span>
  ),
  createData(
    'Consecutive Nouns',
    <span>
      I need to go to the <span style={{ color: '#E86060', fontWeight: 'bold' }}>instruments </span>
      repair shop.
    </span>,
    <span>
      I need to go to the <span style={{ color: '#4C9459', fontWeight: 'bold' }}>instrument </span>
      repair shop.
    </span>
  ),
  createData(
    'Possessive Plural Nouns',
    <span>
      You need both of your <span style={{ color: '#E86060', fontWeight: 'bold' }}>parent’s </span>
      permission.
    </span>,
    <span>
      You need both of your <span style={{ color: '#4C9459', fontWeight: 'bold' }}>parents’ </span>
      permission.
    </span>
  ),
  createData(
    'Unnecessary Prepositions',
    <span>
      Come <span style={{ color: '#E86060', fontWeight: 'bold' }}>to</span> here.
    </span>,
    <span>
      Come<span style={{ color: '#4C9459', fontWeight: 'bold' }}>|</span>here.
    </span>
  ),
];

function GrammarCheckerExplanation() {
  const classes = useStyles();
  const theme = useTheme();

  const renderFAQ = (question: string, answer: string | JSX.Element, style = {}) => (
    <Accordion
      classes={{ root: classes.expPanel }}
      style={{ width: '100%', ...style }}
      onChange={(event, expanded) => {
        if (expanded) supportTrack.faqOpened('Grammar-check FAQ', question);
      }}
    >
      <AccordionSummary
        classes={{ root: classes.root, expanded: classes.expanded }}
        className="qbp-semibold"
        aria-controls="panel1bh-content"
      >
        <Typography className={classes.heading} display="block">
          {question}
        </Typography>
      </AccordionSummary>
      <AccordionDetails classes={{ root: classes.expDetail }} style={{ flexDirection: 'column' }}>
        {answer}
      </AccordionDetails>
    </Accordion>
  );

  return (
    <>
      <div className={`${classes.container} ${classes.ruleBoxBg} container`}>
        <Grid container>
          <Grid item xs={12}>
            <div className={classes.topSection}>
              <h1 className="pageTitle">Grammar Checker</h1>
              <p>
                Use QuillBot’s free online grammar checker tool to perfect your English by reviewing
                your writing for grammar, spelling, and punctuation errors.
              </p>
              <p
                style={{
                  fontStyle: 'italic',
                  fontWeight: 'bold',
                  color: '#4C9459',
                  paddingTop: '8px',
                  paddingBottom: '8px',
                }}
              >
                Trust QuillBot’s Free Grammar Check to Find Errors and Perfect Your Work
              </p>
              <p>
                Writing can be difficult, but perfecting your work with our grammar and sentence
                checker is easy! Whenever you need to review your writing or grammar check
                sentences, QuillBot is here to help make the editing process painless. QuillBot’s
                free online sentence corrector helps you avoid mistakes and polish your writing,
                letting your ideas shine instead of your typos.
              </p>
            </div>
          </Grid>
        </Grid>
        <Grid container className={classes.featureDescription}>
          <Grid item xs={12}>
            <h2 className="pageTitle">One Grammar Checker to Rule Them All</h2>
          </Grid>

          <Grid container className={`${classes.rowReverse} ${classes.grammarRuleBox}`}>
            <Grid
              item
              xs={12}
              sm={8}
              md={9}
              lg={9}
              xl={9}
              className={`${classes.grammarRuleBoxContent} ${classes.grammarRuleBoxContentLeft}`}
            >
              <Typography style={{ fontSize: '20px' }}>Simplify Your Writing Workflow</Typography>
              <p>
                Sick of having so many tabs open to access different writing and research tools? We
                get it. Cut down on common writing roadblocks by minimizing the distractions that
                come with a sea of open tabs. QuillBot has cutting-edge AI-based writing tools for
                <Link href="/">
                  <a target="_blank"> paraphrasing</a>
                </Link>
                ,{' '}
                <Link href="/summarize">
                  <a target="_blank">summarizing</a>
                </Link>
                , and now grammar checking. Create a smooth, simple workflow on our sleek,
                user-friendly interfaces. Save yourself time, energy, and frustration with our
                arsenal of helpful products.
              </p>
            </Grid>
            <Grid item xs={12} sm={4} md={3} lg={3} xl={3} className={classes.textRight}>
              <img
                key={theme.palette.mode}
                data-src={`./images/theme/${theme.palette.mode}/grammarChecker/workflow.svg`}
                alt="workflow"
                className="lazyload"
              />
            </Grid>
          </Grid>

          <Grid container className={`${classes.grammarRuleBox}`}>
            <Grid item xs={12} sm={4} md={3} lg={3} xl={3} className={classes.textLeft}>
              <img
                key={theme.palette.mode}
                data-src={`./images/theme/${theme.palette.mode}/grammarChecker/grammar.svg`}
                alt="grammar"
                className="lazyload"
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={8}
              md={9}
              lg={9}
              xl={9}
              className={`${classes.grammarRuleBoxContent} ${classes.grammarRuleBoxContentRight}`}
            >
              <h3>Correct Grammar</h3>
              <p>
                Should you use
                <Link href="https://quillbot.com/blog/affect-vs-effect/">
                  <a target="_blank"> “effect” or “affect”</a>
                </Link>
                ? What’s the difference between “their,” “there,” and “they’re”? There’s so much to
                remember when it comes to proper English grammar. Luckily, QuillBot has your back
                with the best online grammar checker out there--and it’s free! Don’t worry about
                grammar errors.
              </p>
            </Grid>
          </Grid>

          <Grid container className={`${classes.rowReverse} ${classes.grammarRuleBox}`}>
            <Grid
              item
              xs={12}
              sm={8}
              md={9}
              lg={9}
              xl={9}
              className={`${classes.grammarRuleBoxContent} ${classes.grammarRuleBoxContentLeft}`}
            >
              <h3>Spell Check</h3>
              <p>
                Spelling might seem simple, but the English language has so many unique rules that
                can be hard to remember, even for spell check tools. A lot of these
                less-sophisticated, free spell check tools often miss glaring mistakes, but never
                fear: QuillBot corrects both misspelled and misused words, so you’ll never have to
                worry about those pesky rules again. Spell check your work for free online, and make
                spelling errors a thing of the past.
              </p>
            </Grid>
            <Grid item xs={12} sm={4} md={3} lg={3} xl={3} className={classes.textRight}>
              <img
                key={theme.palette.mode}
                data-src={`./images/theme/${theme.palette.mode}/grammarChecker/spelling.svg`}
                alt="spelling"
                className="lazyload"
              />
            </Grid>
          </Grid>

          <Grid container className={`${classes.grammarRuleBox}`}>
            <Grid item xs={12} sm={4} md={3} lg={3} xl={3} className={classes.textLeft}>
              <img
                key={theme.palette.mode}
                data-src={`./images/theme/${theme.palette.mode}/grammarChecker/punctuation.svg`}
                alt="punctuation"
                className="lazyload"
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={8}
              md={9}
              lg={9}
              xl={9}
              className={`${classes.grammarRuleBoxContent} ${classes.grammarRuleBoxContentRight}`}
            >
              <h3>Check Punctuation</h3>
              <p>
                What’s a comma splice? When is it appropriate to use a semicolon? Does a comma
                belong there? Even those who are great with spelling and grammar can have a tough
                time with punctuation rules, so it’s a good thing QuillBot’s Grammar Checker doubles
                as a punctuation checker. By using our tool, you’re saving your brainpower for
                articulating your ideas and making punctuation errors a thing of the past.
              </p>
            </Grid>
          </Grid>

          <Grid container className={`${classes.rowReverse} ${classes.grammarRuleBox}`}>
            <Grid
              item
              xs={12}
              sm={8}
              md={9}
              lg={9}
              xl={9}
              className={`${classes.grammarRuleBoxContent} ${classes.grammarRuleBoxContentLeft}`}
            >
              <h3>Correct A Multitude of Grammatical Errors with Just One Click</h3>
              <p>
                We care that your workflow is streamlined, which is why we rolled 3 tools into 1
                with our cutting-edge Grammar Checker. It functions as a sentence checker, a spell
                check, and a punctuation checker. QuillBot will grammar check sentences from the
                beginning to the end of any project you’re working on with one simple click, making
                sure that your work is polished and error-free.
              </p>
            </Grid>
            <Grid item xs={12} sm={4} md={3} lg={3} xl={3} className={classes.textRight}>
              <img
                key={theme.palette.mode}
                data-src={`./images/theme/${theme.palette.mode}/grammarChecker/grammaticalErrors.svg`}
                alt="GrammaticalErrors"
                className="lazyload"
              />
            </Grid>
          </Grid>

          <Grid container className={`${classes.grammarRuleBox}`}>
            <Grid
              item
              xs={12}
              sm={4}
              md={3}
              lg={3}
              xl={3}
              className={classes.textLeft}
              style={{ display: 'flex' }}
            >
              <img
                key={theme.palette.mode}
                data-src={`./images/theme/${theme.palette.mode}/grammarChecker/learn.svg`}
                alt="learn"
                className="lazyload"
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={8}
              md={9}
              lg={9}
              xl={9}
              className={`${classes.grammarRuleBoxContent} ${classes.grammarRuleBoxContentLast}`}
            >
              <Typography style={{ fontSize: '20px' }}>
                Turn Corrections into a Learning Experience
              </Typography>
              <p>
                Every writer’s background is different. Some of us took great writing courses, while
                others learned through trial and error. When the grammar checker flags mistakes in
                your writing, it visually brings these issues to your attention, helping you learn
                and grow into a better, more compelling writer.
              </p>
              <p>“That’s how you spell ‘receipt’? I’ve been spelling it wrong forever!”</p>
              <p>
                “I guess I do need a conjunction between these two phrases separated by a comma.
                They are both complete thoughts--I understand comma splices now!”
              </p>
            </Grid>
          </Grid>
        </Grid>
      </div>

      <div className={classes.yellowBoxWave} />
      <Grid container className={classes.yellowBoxHolder}>
        <Grid item xs={12}>
          <div className={`${classes.yellowBoxInner} ${classes.container} container`}>
            <Typography style={{ fontSize: '20px' }} className="pageTitle">
              You asked. We delivered.
            </Typography>
            <p>
              At{' '}
              <Link href="/">
                <a target="_blank">QuillBot</a>
              </Link>
              , we are committed to making writing painless, and that means building the most robust
              writing and research platform in the world. Backed by AI technology, our models are
              more dynamic than any other tools on the market, and we are always looking for ways to
              improve our users’ experience and workflow.
            </p>
            <p>
              You asked for a grammar checker tool to simplify your workflow in conjunction with our
              existing paraphraser and summarizer, so we listened. We’re so excited to present this
              new tool, and we can’t wait to hear about the time savings it provides. Do you have
              other ideas? <br />
              <Link href="/contact">
                <a target="_blank">We want to hear from you.</a>
              </Link>
            </p>
          </div>
        </Grid>
      </Grid>

      <div className={`${classes.container} ${classes.tablemobileBgContainer}  container`}>
        <Grid container className={`${classes.tablemobilePaddingContainer}`}>
          <Grid item xs={12}>
            <div className={`${classes.tableTitle}`}>
              <h4>
                Below are some other examples of grammar, spelling, and punctuation errors that
                QuillBot’s grammar check will identify and help you understand how to fix.
              </h4>
            </div>
            {/* ============ desktop table start  ========================   */}
            <Hidden only={['xs']}>
              <div className={`${classes.tableHolderContent}`}>
                <Table className={`${classes.tableContent}`}>
                  <tbody>
                    <tr>
                      <th className={`${classes.tableTopicTh}`}>
                        <Box className={`${classes.tableBox}`}>
                          <img
                            key={theme.palette.mode}
                            data-src="./images/grammar-checker/TopicImgNew.png"
                            alt="WrongImg"
                            className="lazyload"
                          />
                          Topic
                        </Box>
                      </th>
                      <th className={`${classes.tableWrongTh}`}>
                        <Box className={`${classes.tableBox}`}>
                          <img
                            key={theme.palette.mode}
                            data-src="./images/grammar-checker/WrongImgNew.png"
                            alt="WrongImg"
                            className="lazyload"
                          />
                          Wrong
                        </Box>
                      </th>
                      <th className={`${classes.tableRightTh}`}>
                        <Box className={`${classes.tableBox}`}>
                          <img
                            key={theme.palette.mode}
                            data-src="./images/grammar-checker/RightImgNew.png"
                            alt="RightImg"
                            className="lazyload"
                          />
                          Right
                        </Box>
                      </th>
                    </tr>

                    <tr className={`${classes.evenCell}`}>
                      <td>
                        <strong>Subject-Verb Agreement</strong>
                      </td>
                      <td>
                        <span>
                          My mom <span style={{ color: '#E86060', fontWeight: 'bold' }}>like </span>
                          pizza and tacos.
                        </span>
                      </td>
                      <td>
                        <span>
                          My mom{' '}
                          <span style={{ color: '#4C9459', fontWeight: 'bold' }}>likes </span>
                          pizza and tacos.
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td rowSpan={2}>
                        <strong>Word Misuse</strong>
                      </td>
                      <td>
                        The <span style={{ color: '#E86060', fontWeight: 'bold' }}>affect</span> of
                        this change is unclear.
                      </td>
                      <td>
                        The <span style={{ color: '#4C9459', fontWeight: 'bold' }}>effect</span> of
                        this change is unclear.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        The <span style={{ color: '#E86060', fontWeight: 'bold' }}>effected </span>
                        area is on the right.
                      </td>
                      <td>
                        The <span style={{ color: '#4C9459', fontWeight: 'bold' }}>affected </span>
                        area is on the right.
                      </td>
                    </tr>

                    <tr className={`${classes.evenCell}`}>
                      <td>
                        <strong>Comma Splices</strong>
                      </td>
                      <td>
                        First I went to the grocery store,
                        <span
                          style={{
                            color: '#E86060',
                            fontWeight: 'bold',
                            position: 'relative',
                            top: '10px',
                          }}
                        >
                          ^
                        </span>
                        I went to the library afterwards.
                      </td>
                      <td>
                        First I went to the grocery store,
                        <span style={{ color: '#4C9459', fontWeight: 'bold' }}> and then</span> I
                        went to the library afterwards.
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <strong>Singular vs. Plural Nouns</strong>
                      </td>
                      <td>
                        Four pets found new
                        <span style={{ color: '#E86060', fontWeight: 'bold' }}> home</span> today.
                      </td>
                      <td>
                        Four pets found new
                        <span style={{ color: '#4C9459', fontWeight: 'bold' }}> homes</span> today.
                      </td>
                    </tr>

                    <tr className={`${classes.evenCell}`}>
                      <td>
                        <strong>Consecutive Nouns</strong>
                      </td>
                      <td>
                        I need to go to the
                        <span style={{ color: '#E86060', fontWeight: 'bold' }}> instruments </span>
                        repair shop.
                      </td>
                      <td>
                        I need to go to the
                        <span style={{ color: '#4C9459', fontWeight: 'bold' }}> instrument </span>
                        repair shop.
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <strong>Possessive Plural Nouns</strong>
                      </td>
                      <td>
                        You need both of your
                        <span style={{ color: '#E86060', fontWeight: 'bold' }}> parent’s </span>
                        permission.
                      </td>
                      <td>
                        You need both of your
                        <span style={{ color: '#4C9459', fontWeight: 'bold' }}> parents’ </span>
                        permission.
                      </td>
                    </tr>

                    <tr className={`${classes.evenCell}`}>
                      <td>
                        <strong>Unnecessary Prepositions</strong>
                      </td>
                      <td>
                        Come <span style={{ color: '#E86060', fontWeight: 'bold' }}>to</span> here.
                      </td>
                      <td>
                        Come<span style={{ color: '#4C9459', fontWeight: 'bold' }}>|</span>here.
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Hidden>

            {/* ============ desktop table end  */}

            <Hidden only={['lg', 'md', 'xl', 'sm']}>
              {rows.map((row) => (
                <TableContainer
                  className={classes.tableMobileHolder}
                  component={Box}
                  key={row.topicColumn}
                >
                  <Table className={classes.tableMobile} aria-label="customized table">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell className={classes.tableTopicTh}>
                          <Grid container justifyContent="center" alignItems="center">
                            {row.topicColumn}
                          </Grid>
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      <StyledTableRow>
                        <StyledTableCell component="th" scope="row">
                          <Grid container justifyContent="flex-start" alignItems="center">
                            <Box className={classes.mobileTableBox}>
                              <img
                                key={theme.palette.mode}
                                data-src="./images/grammar-checker/WrongImgNew.png"
                                alt="WrongImg"
                                className="lazyload"
                              />{' '}
                              {row.wrongColumn}
                            </Box>
                          </Grid>
                        </StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow>
                        <StyledTableCell component="th" scope="row">
                          <Grid container justifyContent="flex-start" alignItems="center">
                            <Box className={classes.mobileTableBox}>
                              <img
                                key={theme.palette.mode}
                                data-src="./images/grammar-checker/RightImgNew.png"
                                alt="RightImg"
                                className="lazyload"
                              />{' '}
                              {row.rightColumn}
                            </Box>
                          </Grid>
                        </StyledTableCell>
                      </StyledTableRow>
                      {row.topicColumn === 'Word Misuse' ? (
                        <>
                          <StyledTableRow style={{ borderTop: '0px' }}>
                            <StyledTableCell component="th" scope="row">
                              <Grid container justifyContent="flex-start" alignItems="center">
                                <Box className={classes.mobileTableBox}>
                                  <img
                                    key={theme.palette.mode}
                                    data-src="./images/grammar-checker/WrongImgNew.png"
                                    alt="WrongImg"
                                    className="lazyload"
                                  />{' '}
                                  <span>
                                    The{' '}
                                    <span style={{ color: '#E86060', fontWeight: 'bold' }}>
                                      effected
                                    </span>{' '}
                                    area is on the right.
                                  </span>
                                </Box>
                              </Grid>
                            </StyledTableCell>
                          </StyledTableRow>
                          <StyledTableRow>
                            <StyledTableCell component="th" scope="row">
                              <Grid container justifyContent="flex-start" alignItems="center">
                                <Box className={classes.mobileTableBox}>
                                  <img
                                    key={theme.palette.mode}
                                    data-src="./images/grammar-checker/RightImgNew.png"
                                    alt="RightImg"
                                    className="lazyload"
                                  />{' '}
                                  <span>
                                    The{' '}
                                    <span style={{ color: '#4C9459', fontWeight: 'bold' }}>
                                      affected
                                    </span>{' '}
                                    area is on the right.
                                  </span>
                                </Box>
                              </Grid>
                            </StyledTableCell>
                          </StyledTableRow>
                        </>
                      ) : null}
                    </TableBody>
                  </Table>
                </TableContainer>
              ))}
            </Hidden>
          </Grid>
        </Grid>
      </div>

      <Grid container className={`${classes.faqContainer}`}>
        <Grid item xs={12}>
          <div className={`${classes.container} container`}>
            <Grid container className={`${classes.faqInner}`}>
              <Grid item xs={12}>
                <h4 style={{ textAlign: 'left', marginBottom: '0px' }}>FAQs</h4>
                <p>
                  Below are some of the most Frequently Asked Questions with regard to the Grammar
                  Check tool.
                </p>
              </Grid>

              <Grid item xs={12} className={`${classes.faqholder}`}>
                {renderFAQ(
                  "How does QuillBot's Grammar Checker tool work?",
                  <ol>
                    <li>Either copy and paste your text into the text box or begin typing.</li>
                    <li>Click on each underlined error to view the replacement options.</li>
                    <li>Replace each error one at a time, or hit the “Fix All Errors” button.</li>
                  </ol>,
                  { borderTop: '0' }
                )}
                {renderFAQ(
                  "Who can use QuillBot's Grammar Checker?",
                  `Anyone can use QuillBot's Grammar Checker (and we hope you do). It’s
                  particularly great for students who need to double check their work before
                  handing it in, for professionals who are sending formal correspondence, and for
                  those who are learning English to get acquainted with English grammar rules.`
                )}
                {renderFAQ(
                  'Can this tool be used as a spell checker?',
                  `Absolutely! Our Grammar Checker doubles as a spell check tool to ensure that
                  every part of every sentence you write is correct. It can be hard to keep track
                  of all the moving parts of a writing project, but now you can cross correct
                  spelling off that list━we’ve got it covered.`
                )}
                {renderFAQ(
                  'Can this tool be used as a punctuation checker?',
                  `Our Grammar Checker sure can be used as a punctuation check. Using the correct
                  punctuation is of the utmost importance when trying to communicate effectively,
                  so we know how necessary it is that our tool functions as a grammar and
                  punctuation check.`
                )}
                {renderFAQ(
                  "Is QuillBot's Grammar Checker tool free?",
                  `Yes! Our Grammar Checker is completely free to use. There is no sign up or
                  payment required.`
                )}
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

export default GrammarCheckerExplanation;
